import React, { useState } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useGetAccessLevelList } from "../../hooks/useManagement";
import Button from "../Button/Button";
import DeleteUserAccessModal from "../Dialog/DeleteUserAccessModal";
import { EditAccessLevelModal } from "../Dialog/EditAccessLevelModal";
import Loading from "../Loadings/LoadingTable";
import { Table } from "../Table/Table";

const initModalValue = {
  delete: false,
  edit: false,
};

function AccessLevelTable() {
  const [Search, setSearch] = useState("");
  const [show, setShow] = useState(initModalValue);
  const { data } = useGetAccessLevelList();
  const [modalContent, setModalContent] = useState(null);
  const users = data?.data?.list;

  const TargetListHeaderTitle = [
    "ردیف",
    "نام و نام خانوادگی",
    "دسترسی ها",
    "عملیات",
  ];

  const items = users
    ?.filter((user) => {
      if (Search === "") {
        return user;
      } else if (user.FirstName.includes(Search)) {
        return user;
      } else if (user.LastName.includes(Search)) {
        return user;
      } else {
        return user;
      }
    })
    ?.map((user, index) => {
      return (
        <tr key={index} style={{ cursor: "pointer" }}>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {index + 1}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {(user?.FirstName ? user?.FirstName : "") +
                " " +
                (user?.LastName ? user?.LastName : "")}
            </span>
          </td>

          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {user?.UnitAccounting === "on" ? "واحد حسابداری - " : ""}
              {user?.UnitCRM === "on" ? "واحد CRM - " : ""}
              {user?.UnitContent === "on" ? "واحد محتوا - " : ""}
              {user?.UnitManagement === "on" ? "واحد مدیریت" : ""}
            </span>
          </td>

          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              <div className="d-flex">
                <Button
                  small="fit-content"
                  bgColor="#009ef7"
                  className="mx-1"
                  onclick={() => {
                    setModalContent(user);
                    setShow({ ...show, edit: true });
                  }}
                >
                  <FaEdit size="16px" color="#fff" />
                </Button>
                <Button
                  small="fit-content"
                  bgColor="#f1416c"
                  className="mx-1"
                  onclick={() => {
                    setShow({
                      ...show,
                      delete: true,
                    });
                    setModalContent(user.IdMonshis);
                  }}
                >
                  <FaTrash size="16px" color="#fff" />
                </Button>
              </div>
            </span>
          </td>
        </tr>
      );
    });
  return (
    <>
      <Table
        className="mt-3"
        setSearch={setSearch}
        headerTitle={TargetListHeaderTitle}
        items={items ? items : <Loading />}
        title={`همکاران`}
      />
      <DeleteUserAccessModal
        show={show.delete}
        handleClose={() => setShow({ ...show, delete: false })}
        id={modalContent}
      />
      <EditAccessLevelModal
        show={show.edit}
        handleClose={() => setShow({ ...show, edit: false })}
        item={modalContent}
      />
    </>
  );
}

export default AccessLevelTable;
